<template>
  <nav class="bg-gray sm:text-xl text-xs sm:p-0 p-2">
    <div class="w-4/5 sm:flex text-white gap-0 sm:gap-4 justify-end">
      <p class="sm:pt-4 sm:pb-4">โทร - 1323</p>
      <div class="w-0.5 bg-white h"></div>
      <div class="flex gap-2 sm:pt-4 sm:pb-4">
        <p>การเช็คความเสี่ยงต่อการเป็น PEDOPHILIA</p>
      </div>
    </div>
  </nav>
  <header class="p-10">
    <h1 class="uppercase font-head text-4xl sm:text-6xl">pedophilia</h1>
    <p class="text-xl">คุณเข้าข่ายโรคคลั่งเด็กหรือไม่</p>
  </header>
  <section class="items-center w-full flex text-xl flex-col gap-1">
    <h2 class="font-bold">แบบทดสอบ PEDOPHILIA</h2>
    <div class="w-full items-center flex flex-col">
      <div class="w-1/4 bg-orange h-3"></div>
      <div class="w-full bg-orange h-0.5"></div>
    </div>
  </section>

  <section class="items-center flex flex-col">
    <img :src="kid" alt="kid" class="sm:w-1/4 w-1/2" />
    <p class="w-3/4 bg-orange sm:text-lg sm:p-8 p-2 rounded-lg sm:rounded-3xl">
      "พีโดฟิเลีย” (Pedophilia) คือ
      หนึ่งในอาการบกพร่องทางจิตประเภทหนึ่งในกลุ่มโรคกามวิปริตที่มักเกิดความต้องการทางเพศกับเด็ก
      มีความหมายในทางลบที่บ่งบอกถึงภาวะความผิดปกติทางจิตของตัวบุคคล
      โรคทางจิตเวชที่ผู้ป่วยซึ่งเป็นผู้ใหญ่มักเกิดความรู้สึกเร้าอารมณ์ทางเพศเมื่อได้เห็นหรือสัมผัสใกล้ชิดกับเด็ก
      โดยมักจะเกิดอารมณ์เมื่อเห็นภาพเด็ก และเกิดความติดตาตรึงใจ
      จนอาจล่อลวงหรือทำร้ายเด็กเพื่อตอบสนองอารมณ์ทางเพศของตัวเอง
    </p>
  </section>

  <section class="flex flex-col gap-4 p-8 sm:p-16 items-center sm:items-start">
    <h1 class="text-2xl font-bold">คำชี้แจง</h1>
    <div class="flex flex-col gap-4 items-center sm:items-start">
      <div class="flex gap-4 sm:flex-row flex-col items-center">
        <img :src="gear" alt="gear" class="h-10 w-10" />
        <p class="text-lg text-center sm:text-start">
          กรุณาเลือกคำตอบในช่องที่มีข้อความตรงกับตัวท่านมากที่สุด
          และขอความร่วมมือตอบคำถามทุกข้อ
        </p>
      </div>
      <div class="flex gap-4 sm:flex-row flex-col items-center">
        <img :src="handshake" alt="handshake" class="h-10" />
        <p class="text-lg text-center sm:text-start">
          คำถามต่อไปนี้จะถามถึงประสบการณ์ของท่านในช่วง 1 เดือนที่ผ่านมา
          จนถึงปัจจุบัน ให้ท่านสำรวจตัวท่านเองและประเมินเหตุการณ์
          อาการหรือความคิดเห็นและความรู้สึกของท่าน ว่าอยู่ในระดับใด
          แล้วตอบลงในช่องคำตอบที่เป็นจริงกับตัวท่านมากที่สุด
        </p>
      </div>
    </div>
  </section>

  <section class="flex w-full items-center flex-col gap-16 mb-16">
    <section class="border-4 border-double w-3/5 p-4 text-lg pt-16 pb-16">
      <h1 class="sm:text-xl font-bold">คุณชอบคลุกคลีกับกับเด็ก</h1>
      <div class="flex flex-col gap-2 p-4 pb-0 pt-2">
        <div>
          <input type="radio" id="q1Yes" name="q1" value="yes" v-model="q1" />
          <label class="p-1" for="q1Yes">ใช่</label>
        </div>
        <div>
          <input type="radio" id="q1No" name="q1" value="no" v-model="q1" />
          <label class="p-1" for="q1No">ไม่ใช่</label>
        </div>
      </div>
    </section>

    <section class="border-4 border-double w-3/5 p-4 text-lg pt-16 pb-16">
      <h1 class="sm:text-xl font-bold">คุณมีความคิดที่ไม่เป็นหลักแหล่งสับสน</h1>
      <div class="flex flex-col gap-2 p-4 pb-0 pt-2">
        <div>
          <input type="radio" id="q2Yes" name="q2" value="yes" v-model="q2" />
          <label class="p-1" for="q2Yes">ใช่</label>
        </div>
        <div>
          <input type="radio" id="q2No" name="q2" value="no" v-model="q2" />
          <label class="p-1" for="q2No">ไม่ใช่</label>
        </div>
      </div>
    </section>

    <section class="border-4 border-double w-3/5 p-4 text-lg pt-16 pb-16">
      <h1 class="sm:text-xl font-bold">คุณอยากมีอำนาจเหนือเด็ก</h1>
      <div class="flex flex-col gap-2 p-4 pb-0 pt-2">
        <div>
          <input type="radio" id="q3Yes" name="q3" value="yes" v-model="q3" />
          <label class="p-1" for="q3Yes">ใช่</label>
        </div>
        <div>
          <input type="radio" id="q3No" name="q3" value="no" v-model="q3" />
          <label class="p-1" for="q3No">ไม่ใช่</label>
        </div>
      </div>
    </section>

    <section class="border-4 border-double w-3/5 p-4 text-lg pt-16 pb-16">
      <h1 class="sm:text-xl font-bold">คุณรู้สึกชอบใช้ความรุนแรงกับผู้อื่น</h1>
      <div class="flex flex-col gap-2 p-4 pb-0 pt-2">
        <div>
          <input type="radio" id="q4Yes" name="q4" value="yes" v-model="q4" />
          <label class="p-1" for="q4Yes">ใช่</label>
        </div>
        <div>
          <input type="radio" id="q4No" name="q4" value="no" v-model="q4" />
          <label class="p-1" for="q4No">ไม่ใช่</label>
        </div>
      </div>
    </section>

    <section class="border-4 border-double w-3/5 p-4 text-lg pt-16 pb-16">
      <h1 class="sm:text-xl font-bold">คุณแยกตัวออกจากเพื่อนและครอบครัว</h1>
      <div class="flex flex-col gap-2 p-4 pb-0 pt-2">
        <div>
          <input type="radio" id="q5Yes" name="q5" value="yes" v-model="q5" />
          <label class="p-1" for="q5Yes">ใช่</label>
        </div>
        <div>
          <input type="radio" id="q5No" name="q5" value="no" v-model="q5" />
          <label class="p-1" for="q5No">ไม่ใช่</label>
        </div>
      </div>
    </section>

    <section class="border-4 border-double w-3/5 p-4 text-lg pt-16 pb-16">
      <h1 class="sm:text-xl font-bold">
        คุณไม่มีความสุขกับคู่ครองในวัยเดียวกันหรือใกล้เคียงกัน
      </h1>
      <div class="flex flex-col gap-2 p-4 pb-0 pt-2">
        <div>
          <input type="radio" id="q6Yes" name="q6" value="yes" v-model="q6" />
          <label class="p-1" for="q6Yes">ใช่</label>
        </div>
        <div>
          <input type="radio" id="q6No" name="q6" value="no" v-model="q6" />
          <label class="p-1" for="q6No">ไม่ใช่</label>
        </div>
      </div>
    </section>

    <section class="border-4 border-double w-3/5 p-4 text-lg pt-16 pb-16">
      <h1 class="sm:text-xl font-bold">
        คุณเกิดอารมณ์ทางเพศกับเด็ก รูปภาพ คลิปวิดีโอเด็ก
      </h1>
      <div class="flex flex-col gap-2 p-4 pb-0 pt-2">
        <div>
          <input type="radio" id="q7Yes" name="q7" value="yes" v-model="q7" />
          <label class="p-1" for="q7Yes">ใช่</label>
        </div>
        <div>
          <input type="radio" id="q7No" name="q7" value="no" v-model="q7" />
          <label class="p-1" for="q7No">ไม่ใช่</label>
        </div>
      </div>
    </section>

    <section class="border-4 border-double w-3/5 p-4 text-lg pt-16 pb-16">
      <h1 class="sm:text-xl font-bold">
        คุณคิดว่าการมีเพศสัมพันธุ์กับเด็กเป็นเรื่องปกติหรือไม่
      </h1>
      <div class="flex flex-col gap-2 p-4 pb-0 pt-2">
        <div>
          <input type="radio" id="q8Yes" name="q8" value="yes" v-model="q8" />
          <label class="p-1" for="q8Yes">ใช่</label>
        </div>
        <div>
          <input type="radio" id="q8No" name="q8" value="no" v-model="q8" />
          <label class="p-1" for="q8No">ไม่ใช่</label>
        </div>
      </div>
    </section>

    <section class="border-4 border-double w-3/5 p-4 text-lg pt-16 pb-16">
      <h1 class="sm:text-xl font-bold">
        คุณมีความรู้สึกเบื่อหน่ายอยู่บ่อยครั้ง
      </h1>
      <div class="flex flex-col gap-2 p-4 pb-0 pt-2">
        <div>
          <input type="radio" id="q9Yes" name="q9" value="yes" v-model="q9" />
          <label class="p-1" for="q9Yes">ใช่</label>
        </div>
        <div>
          <input type="radio" id="q9No" name="q9" value="no" v-model="q9" />
          <label class="p-1" for="q9No">ไม่ใช่</label>
        </div>
      </div>
    </section>

    <section class="border-4 border-double w-3/5 p-4 text-lg pt-16 pb-16">
      <h1 class="sm:text-xl font-bold">คุณมีความคิดแปลก ๆ</h1>
      <div class="flex flex-col gap-2 p-4 pb-0 pt-2">
        <div>
          <input
            type="radio"
            id="q10Yes"
            name="q10"
            value="yes"
            v-model="q10"
          />
          <label class="p-1" for="q10Yes">ใช่</label>
        </div>
        <div>
          <input type="radio" id="q10No" name="q10" value="no" v-model="q10" />
          <label class="p-1" for="q10No">ไม่ใช่</label>
        </div>
      </div>
    </section>

    <section class="border-4 border-double w-3/5 p-4 text-lg pt-16 pb-16">
      <h1 class="sm:text-xl font-bold">
        คุณรู้สึกไม่เข้ากับคนวัยเดียวกันหรือใกล้เคียงกัน
      </h1>
      <div class="flex flex-col gap-2 p-4 pb-0 pt-2">
        <div>
          <input
            type="radio"
            id="q11Yes"
            name="q11"
            value="yes"
            v-model="q11"
          />
          <label class="p-1" for="q11Yes">ใช่</label>
        </div>
        <div>
          <input type="radio" id="q11No" name="q11" value="no" v-model="q11" />
          <label class="p-1" for="q11No">ไม่ใช่</label>
        </div>
      </div>
    </section>

    <section class="border-4 border-double w-3/5 p-4 text-lg pt-16 pb-16">
      <h1 class="text-xl font-bold">
        คุณมีลักษณะที่ดูเจ้าระเบียบ เข้มงวด ตื่นเต้นง่าย
      </h1>
      <div class="flex flex-col gap-2 p-4 pb-0 pt-2">
        <div>
          <input
            type="radio"
            id="q12Yes"
            name="q12"
            value="yes"
            v-model="q12"
          />
          <label class="p-1" for="q12Yes">ใช่</label>
        </div>
        <div>
          <input type="radio" id="q12No" name="q12" value="no" v-model="q12" />
          <label class="p-1" for="q12No">ไม่ใช่</label>
        </div>
      </div>
    </section>

    <section class="border-4 border-double w-3/5 p-4 text-lg pt-16 pb-16">
      <h1 class="sm:text-xl font-bold">
        เคยมีเจ้าหน้าที่ทางการแพทย์บอกคุณว่าคุณป่วยโรคอาการทางจิต
      </h1>
      <div class="flex flex-col gap-2 p-4 pb-0 pt-2">
        <div>
          <input
            type="radio"
            id="q13Yes"
            name="q13"
            value="yes"
            v-model="q13"
          />
          <label class="p-1" for="q13Yes">ใช่</label>
        </div>
        <div>
          <input type="radio" id="q13No" name="q13" value="no" v-model="q13" />
          <label class="p-1" for="q13No">ไม่ใช่</label>
        </div>
      </div>
    </section>

    <section class="border-4 border-double w-3/5 p-4 text-lg pt-16 pb-16">
      <h1 class="sm:text-xl font-bold">คุณมีพฤติกรรมต่อต้านสังคม</h1>
      <div class="flex flex-col gap-2 p-4 pb-0 pt-2">
        <div>
          <input
            type="radio"
            id="q14Yes"
            name="q14"
            value="yes"
            v-model="q14"
          />
          <label class="p-1" for="q14Yes">ใช่</label>
        </div>
        <div>
          <input type="radio" id="q14No" name="q14" value="no" v-model="q14" />
          <label class="p-1" for="q14No">ไม่ใช่</label>
        </div>
      </div>
    </section>

    <section class="border-4 border-double w-3/5 p-4 text-lg pt-16 pb-16">
      <h1 class="sm:text-xl font-bold">
        เวลาที่คุณรู้สึกหงุดหงิด คุณจะรู้สึกโกรธขึ้นมาได้ง่ายมาก
      </h1>
      <div class="flex flex-col gap-2 p-4 pb-0 pt-2">
        <div>
          <input
            type="radio"
            id="q15Yes"
            name="q15"
            value="yes"
            v-model="q15"
          />
          <label class="p-1" for="q15Yes">ใช่</label>
        </div>
        <div>
          <input type="radio" id="q15No" name="q15" value="no" v-model="q15" />
          <label class="p-1" for="q15No">ไม่ใช่</label>
        </div>
      </div>
    </section>

    <p
      class="p-8 pr-16 pl-16 rounded-full bg-orange hover:cursor-pointer"
      @click="checkAnswer"
    >
      ส่งคำตอบ
    </p>
  </section>

  <section
    v-show="show"
    class="w-screen h-screen bg-[#084ecd] fixed top-0 flex justify-center items-center"
  >
    <div
      class="bg-orange w-11/12 sm:w-2/4 rounded-lg sm:text-2xl p-4 flex items-center justify-evenly flex-col m-auto h-1/3 border-solid border-2"
    >
      <P>ความเสี่ยงของคุณคือ {{ probability }}% ที่จะเป็น Pedophilia</P>
      <a @click="close" class="p-4 bg-gray pr-10 pl-10 roun">ปิด</a>
    </div>
  </section>

  <footer
    class="bg-gray p-4 flex items-between justify-around flex-col sm:flex-row text-center"
  >
    <a href="http://www.freepik.com">Designed by pikisuperstar / Freepik</a>
    <p>
      หมายเหตุ ผลงานชิ้นนี้เป็นเพียงPrototypeสำหรับYSLC#5
      ไม่ควรนำไปอ้างอิงทางการแพทย์
    </p>
  </footer>
</template>

<script>
import kid from "./assets/image/kid.png";
import gear from "./assets/image/tools.png";
import handshake from "./assets/image/handshake.png";

export default {
  name: "App",
  data() {
    return {
      kid,
      gear,
      handshake,
      q1: null,
      q2: null,
      q3: null,
      q4: null,
      q5: null,
      q6: null,
      q7: null,
      q8: null,
      q9: null,
      q10: null,
      q11: null,
      q12: null,
      q13: null,
      q14: null,
      q15: null,
      score: 0,
      probability: "",
      show: "",
    };
  },
  methods: {
    checkAnswer() {
      if (this.q1 == "yes") {
        this.score++;
      }
      if (this.q2 == "yes") {
        this.score++;
      }
      if (this.q3 == "yes") {
        this.score++;
      }
      if (this.q4 == "yes") {
        this.score++;
      }
      if (this.q5 == "yes") {
        this.score++;
      }
      if (this.q6 == "yes") {
        this.score++;
      }
      if (this.q7 == "yes") {
        this.score++;
      }
      if (this.q8 == "yes") {
        this.score++;
      }
      if (this.q9 == "yes") {
        this.score++;
      }
      if (this.q10 == "yes") {
        this.score++;
      }
      if (this.q11 == "yes") {
        this.score++;
      }
      if (this.q12 == "yes") {
        this.score++;
      }
      if (this.q13 == "yes") {
        this.score++;
      }
      if (this.q14 == "yes") {
        this.score++;
      }
      if (this.q15 == "yes") {
        this.score++;
      }
      var s = (this.score / 15) * 100;
      this.probability = s.toFixed(2);
      this.show = true;
    },
    close() {
      this.show = false;
      this.probability = "";
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Fahkwang:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;1,200;1,300;1,400;1,500;1,600;1,700&family=Prompt:ital,wght@0,300;1,300&display=swap");

#app {
  font-family: "Prompt", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
}

body {
  background-color: #084ecd;
}
</style>
